import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import PacketPage from '../components/PacketPage';

class PacketOfDelegate extends Component {
  constructor(props) {
    super(props)
    this.delegateId = this.props.match.params.delegateId
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.delegateSites(
          {
            delegateId: this.delegateId
          },
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      fetchPackets: (params, callback) => {
        DataFetcher.delegatePackets(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback
          }
        )
      },
      createPacket: (params, callback, completed) => {
        DataFetcher.delegateCreatePacket(
          {
            ...params,
            delegateId: this.delegateId,
          },
          {
            success: callback,
            completed
          }
        )
      },
      updatePacket: (params, callback, completed) => {
        DataFetcher.delegateUpdatePacket(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback,
            completed
          }
        )
      },
      deletePacket: (params, callback) => {
        DataFetcher.delegateDeletePacket(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      delegateProfile: (params, callback) => {
        DataFetcher.delegateProfile(
          {
            ...params,
            id: this.delegateId
          }, 
          {
            success: callback
          }
        )
      }
    }

    return <PacketPage {...pageProps}/>
  }
}

export default PacketOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/PacketOfDelegate.js